import { QueryTuple, useLazyQuery } from '@apollo/client';
import { Equipment } from '@bechtel/sr-types';
import { GET_EQUIPMENT_BY_IDS } from '~/gql';

export function useEquipmentByIdsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ equipmentByIds: Equipment[] }, Record<string, any>> {
  const response = useLazyQuery<{
    equipmentByIds: Equipment[];
  }>(
    GET_EQUIPMENT_BY_IDS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
